export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const ADJUST_QTY = 'ADJUST_QTY';
export const LOAD_CART = 'LOAD_CART';
export const CLEAR_CART = 'CLEAR_CART';

export const LOAD_DESIGN_ATTACHMENT = 'LOAD_DESIGN_ATTACHMENT';
export const SAVE_DESIGN_ATTACHMENT = 'SAVE_DESIGN_ATTACHMENT';
export const CLEAR_DESIGN_ATTACHMENT = 'CLEAR_DESIGN_ATTACHMENT';